import { ReactNotificationOptions, store } from 'react-notifications-component';

const notificationBuilder = (options: ReactNotificationOptions): string => {
  if (process.env.NODE_ENV !== 'test') {
    return store.addNotification({
      ...options,
      insert: 'top',
      dismiss: {
        duration: 5000,
      },
    });
  }
  return '';
};

type NotificationOptions = Omit<ReactNotificationOptions, 'id' | 'title' | 'message'>;

export const addErrorNotification = (
  id: string,
  title: string,
  message: string,
  options?: NotificationOptions,
): string => {
  return notificationBuilder({
    id,
    title,
    message,
    type: 'danger',
    container: 'bottom-right',
    ...options,
  });
};

export const addSuperErrorNotification = (
  id: string,
  title: string,
  message: string,
  options?: NotificationOptions,
): string => {
  return notificationBuilder({
    id,
    title,
    message,
    type: 'danger',
    container: 'top-center',
    ...options,
  });
};

export const addWarningNotification = (
  id: string,
  title: string,
  message: string,
  options?: NotificationOptions,
): string => {
  return notificationBuilder({
    id,
    title,
    message,
    type: 'warning',
    container: 'top-center',
    ...options,
  });
};

export const addSuccessNotification = (
  id: string,
  title: string,
  message: string,
  options?: NotificationOptions,
): string => {
  return notificationBuilder({
    id,
    title,
    message,
    type: 'success',
    container: 'top-center',
    ...options,
  });
};
